document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll('.locale-button').forEach(btn => {
    btn.addEventListener('click', function(e){

      const form = this.closest('form');
      if (!form) return;

      const langs = Array.isArray(JSON.parse(this.dataset.languages)) 
          ? JSON.parse(this.dataset.languages) 
          : [JSON.parse(this.dataset.languages)];

      const locale = langs[0].shop_locale.locale;
      const localeInput = form.querySelector('input[name="locale_code"]');

      localeInput.value = locale;

      const params = new FormData(form);
      const queryString = new URLSearchParams(params).toString();

    });
  });

});
